import React, { useEffect, useRef } from "react";
import * as SpinStyles from "./styles/Spin";
import * as Styles from "./styles/InteriorSpin";
import PreLoader from "../../../../../../../common-deprecated/styles/lexus/Preloader";
import { BnbLabel } from "../../../../utils/labels";
import IconRefresh from "../../../../svg/lexus/refresh.svg";
import { trackCustomizeInt360Spin } from "../../../../utils/tracking";
import useInteriorSpin from "../../../../hooks/shared/useInteriorSpin";

type PropsType = {
    visible?: boolean;
    fullscreen?: boolean;
};

const InteriorSpin3D = (props: PropsType): JSX.Element => {
    const { visible, fullscreen } = props;

    const canvasElement = useRef<HTMLCanvasElement>(null);
    const { loading, initialized, dragged } = useInteriorSpin(canvasElement, !!visible, !!fullscreen, false);

    // Track the first time the user changed the car angle
    const anyCarWasSpun = useRef(false);
    useEffect(() => {
        if (anyCarWasSpun.current || !dragged) return;
        anyCarWasSpun.current = true;
        trackCustomizeInt360Spin();
    }, [dragged]);

    return (
        <Styles.Wrapper fullscreen={fullscreen}>
            {loading || !initialized ? (
                <PreLoader delayedVisibility />
            ) : (
                !dragged && (
                    <SpinStyles.CenterLabel hasText>
                        <IconRefresh width="16" height="16" />
                        <BnbLabel label="spinDragToRotate" />
                    </SpinStyles.CenterLabel>
                )
            )}
            <Styles.CanvasWrapper>
                <canvas ref={canvasElement} />
            </Styles.CanvasWrapper>
        </Styles.Wrapper>
    );
};

export default InteriorSpin3D;
